var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"variant":"5"},scopedSlots:_vm._u([{key:"pageContent",fn:function(){return [_c('UsersListBy'),[_c('router-view')]]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }